<article class="block-carroussel section-inset-y" *ngIf="block.carrousselItems" (fstrInViewport)="initSwiper()" [once]="true">
  <div class="container">
    <header class="block-carroussel__header d-flex">
      <h1 class="text-light mb-0 splitting splitting--word-in fs-display-3" data-split>{{ block.title }}</h1>
      <div class="d-flex flex-gap-4">
        <button
          aria-label="Vorige"
          (click)="slidePrev()"
          [disabled]="swiperIndex$() < 1"
          class="block-carroussel__nav-button button type--prev button button-icon button--secondary button--lg"
        >
          <fstr-icon anchor="icon-arrow-left"></fstr-icon>
        </button>

        <button
          aria-label="Volgende"
          (click)="slideNext()"
          [disabled]="swiperIndex$() + 1 >= block.carrousselItems.length"
          class="block-carroussel__nav-button type--next button button button-icon button--secondary button--lg"
        >
          <fstr-icon anchor="icon-arrow-right"></fstr-icon>
        </button>
      </div>
    </header>
  </div>
  <main class="block-carroussel__main">
    <div class="container">
      <div class="pull-e">
        @defer {
        <swiper-container init="false" #swiper>
          <swiper-slide class="pt-7" *ngFor="let item of block.carrousselItems; let i = index; trackBy: trackByFn">
            <app-workshop-card [item]="item" [active]="i === swiperIndex$()"></app-workshop-card>
          </swiper-slide>
          <swiper-slide class="pt-7"></swiper-slide>
        </swiper-container>
        }
      </div>
    </div>
  </main>
</article>
